import React, { useState } from 'react';
import Select from 'react-select';
import { SingleDatePicker } from 'react-dates';
import { DocumentsGroup } from 'store/modules/documents_store/types';

interface DocumentsTypes {
  [key: string]: string;
}

interface FilesDescriptionTypes {
  [key: string]: string;
}

interface FileDocumentDataProps {
  index: number;
  setDocSelected: React.Dispatch<React.SetStateAction<number>>;
  docSelected: number;
  validareForm: boolean;
  documentGroupList: Array<DocumentsGroup>;
  documentTypesOptions: Array<DocumentsTypes>;
  filesDescription: any;
  file: any;
  setFilesDescription: React.Dispatch<React.SetStateAction<FilesDescriptionTypes>>;
}

const FileDocumentData = (props: FileDocumentDataProps) => {
  const {
    index,
    setDocSelected,
    docSelected,
    validareForm,
    documentGroupList,
    documentTypesOptions,
    filesDescription,
    file,
    setFilesDescription,
  } = props;
  const [dateVencimento, setDateVencimento] = useState<any | null>(null);
  const [docSelectedType, setDocSelectedType] = useState<any>({});
  const [dateFocus, setDateFocus] = useState<boolean>(false);

  return (
    <div>
      <div className="row mb-1">
        <div className="form-group col-12 col-md-6 required-upload">
          <Select
            name={`document_group_id-${index}`}
            className={`${docSelected === 0 && validareForm && 'border border-danger rounded'}`}
            closeMenuOnSelect
            options={documentGroupList}
            noOptionsMessage={() => 'Selecione a classificação do documento'}
            placeholder="Selecione a classificação do documento"
            onChange={(selected) => {
              setDocSelected(selected?.value as any);
            }}
          />
        </div>
        <div className="form-group col-12 col-md-6 required-upload">
          <Select
            name={`document_type_id-${index}`}
            id={`document_type_id-${index}`}
            className={`${docSelectedType === 0 && validareForm && 'border border-danger rounded'}`}
            closeMenuOnSelect
            options={documentTypesOptions}
            noOptionsMessage={() => 'Selecione o tipo de documento'}
            placeholder="Selecione o tipo de documento"
            onChange={(selected) => {
              setDocSelectedType(selected?.value as string);
            }}
          />
        </div>
      </div>
      <div className="row mb-1">
        <div className="form-group col-12 col-md-8 required-upload">
          <input
            className="form-control"
            id="description"
            name="file-description"
            type="text"
            value={filesDescription[file.name] || ''}
            onChange={(event) =>
              setFilesDescription({
                ...filesDescription,
                [`${file.name}`]: event.target.value,
              })
            }
            placeholder="Insira uma descrição para o documento (opcional)"
          />
        </div>
        <div className="form-group col-12 col-md-4 required-upload">
          <SingleDatePicker
            placeholder="Vencimento"
            regular={false}
            date={dateVencimento}
            small
            required
            orientation="horizontal"
            anchorDirection="right"
            block={false}
            numberOfMonths={1}
            onDateChange={(date) => setDateVencimento(date)}
            focused={dateFocus}
            openDirection="down"
            onFocusChange={({ focused }) => setDateFocus(focused)}
            hideKeyboardShortcutsPanel
            id={`expirationDate-${index}`}
          />
        </div>
      </div>
    </div>
  );
};

export default FileDocumentData;
